import { render, staticRenderFns } from "./icon-alert-triangle.vue?vue&type=template&id=44f73a06&"
import script from "./icon-alert-triangle.vue?vue&type=script&lang=js&"
export * from "./icon-alert-triangle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports